import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=70557539&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=ts&"
export * from "./comment.vue?vue&type=script&lang=ts&"
import style0 from "./comment.vue?vue&type=style&index=0&id=70557539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70557539",
  null
  
)

export default component.exports